module.exports = __webpack_public_path__ + "static/media/13203.034a62da.jpg";